import { GROUPS_TABLE_COLUMN_LABELS } from "@components/table/groups/groups-table-constants";
/** Default groups sort by option */
export const DEFAULT_GROUPS_SORT_BY = "name_ascending";

/** Available groups sort field options */
export const GROUPS_SORT_OPTIONS = {
  name: {
    field: "name",
    label: GROUPS_TABLE_COLUMN_LABELS.name
  },
  members: {
    field: "members",
    label: GROUPS_TABLE_COLUMN_LABELS.members
  },
  projects: {
    field: "projects",
    label: GROUPS_TABLE_COLUMN_LABELS.projects
  },
  createdDate: {
    field: "createdDate",
    label: GROUPS_TABLE_COLUMN_LABELS.createdDate
  }
};

/** Map of the sort by options to the SortItem format */
export const GROUPS_SORT_BY_MAP = {
  ["name_ascending"]: {
    field: "name",
    sort: "asc"
  },
  ["name_descending"]: {
    field: "name",
    sort: "desc"
  },
  ["members_ascending"]: {
    field: "members",
    sort: "asc"
  },
  ["members_descending"]: {
    field: "members",
    sort: "desc"
  },
  ["projects_ascending"]: {
    field: "projects",
    sort: "asc"
  },
  ["projects_descending"]: {
    field: "projects",
    sort: "desc"
  },
  ["created_date_ascending"]: {
    field: "createdDate",
    sort: "asc"
  },
  ["created_date_descending"]: {
    field: "createdDate",
    sort: "desc"
  }
};